import React from 'react';

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <div className="flex items-center mb-6 mt-4">
      {[...Array(totalSteps)].map((_, index) => (
        <React.Fragment key={index}>
          <div
            className={`h-1 w-12 rounded-full ${
              index < currentStep ? 'bg-violet' : 'bg-gray-300'
            }`}
          />
          {index < totalSteps - 1 && <div className="w-2" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressIndicator;
